import { render } from "./App.vue?vue&type=template&id=edb2a97a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=edb2a97a&lang=scss"
import "./App.vue?vue&type=style&index=1&id=edb2a97a&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__